<template>
   <div
      class="side-bar"
      :style="{maxHeight: `${maxHeight}px`}"
      :class="{'hide': !showSidebar}"
      >
      <collapse accordion v-model='activeName'>
         <fertility-group
            :accordian-parent-id="accordianId"
            :language-is-english="languageIsEnglish"
         />
         <population-layer-group
            :accordian-parent-id="accordianId"
            :language-is-english="languageIsEnglish"
         />
      </collapse>
   </div>
</template>

<script>
import { Collapse, } from 'element-ui';
import PopulationLayerGroup from './PopulationLayerGroup';
import FertilityGroup from './FertiliyGroup';

export default {
   name: "SideBar",
   props: {
      showSidebar: {type: Boolean, required: true},
      languageIsEnglish: {type: Boolean, required: true},
   },
   components: {
      PopulationLayerGroup,
      FertilityGroup,
      Collapse,
   },
   data() {
      return {
         maxHeight: 0,
         accordianId: 'layerAccordian',
         activeName: 'fertility-group',
      }
   },
   mounted()
   {
      // Code to match the sidebar height with the map wrapper div while keeping the auto scroll 
      const mapWrapper = document.getElementById('map-wrapper');
      this.maxHeight = mapWrapper.clientHeight;
      let setTimeout = null;
      window.onresize = () =>
      {
         if (setTimeout) clearTimeout(setTimeout)
         window.setTimeout(() => {
            this.maxHeight = document.getElementById('map-wrapper').clientHeight;
         }, 200);
      };
   },
   methods: {
   }
}
</script>

<style lang="scss">
.side-bar {
   flex: 1 0 180px;
   padding: 0.4em;
   box-sizing: border-box;
   height: 100%;
   /* min-height: 500px; */
   width: 100%;
   position: relative;
   overflow-y: auto;
}

.side-bar.hide {
   flex: 0 0 0;
   padding: 0;
   /* height: 500px; */
}

.side-bar.hide div {
   opacity: 0;
}


</style>
